import { render, staticRenderFns } from "./PolicyMainFull.vue?vue&type=template&id=553fba90"
import script from "./PolicyMainFull.vue?vue&type=script&lang=js"
export * from "./PolicyMainFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports